import Model from './Model'

export default class BuildingConfigModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'buildingConfigs'
  }
}
